export const messages = {
  'off': 'Увага! Сповіщення вимкнені, Ви не будете отримувати повідомлення про урок в Telegram'
};